import { Component, ViewChild, ElementRef } from '@angular/core';
import { FormBuilder, AbstractControl, UntypedFormControl } from '@angular/forms'
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { LiveAnnouncer } from '@angular/cdk/a11y';
import { ProductserviceService } from 'src/app/service/productservice.service';
import { SearchService } from 'src/app/service/search.service';
import { Router, ActivatedRoute } from '@angular/router';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { DatePipe } from '@angular/common';
import { TaskDataSource } from 'src/app/service/task.datasource';
import { DashboardService } from 'src/app/service/dashboard.service';
import { tap } from 'rxjs/operators';
import { merge, BehaviorSubject, Observable } from 'rxjs';
import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { Globals } from 'src/app/service/global';
import { searchTourValues, taskTourValues } from 'src/environments/environment';
import { SideNavServiceService } from 'src/app/service/side-nav-service.service';
import { MeetingService } from 'src/app/service/meeting.service';
export const MY_FORMATS = {
  parse: {
    dateInput: 'LL',
  },
  display: {
    dateInput: 'MMM DD, yyyy',
    monthYearLabel: 'YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'YYYY',
  },
};
@Component({
  selector: 'app-task-search-grid',
  templateUrl: './task-search-grid.component.html',
  styleUrls: ['./task-search-grid.component.css'],
  providers: [{ provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },

  { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS }
    , DatePipe]
})
export class TaskSearchGridComponent {
  taskTourValues = taskTourValues
  @ViewChild(MatPaginator)
  paginator!: MatPaginator;
  @ViewChild(MatSort)
  sort!: MatSort;
  @ViewChild('input', { static: true })
  input!: ElementRef;

  dataTableJson: any;
  columns: any;
  rowData: any;
  displayedColumns: string[] = ['taskTitle', 'assignedBy', 'assignedTo', 'dueDate', 'status', 'meetingTitle'];
  taskTitleFilter = new UntypedFormControl('');
  assignedByFilter = new UntypedFormControl('');
  assignedToFilter = new UntypedFormControl('');
  dueDateFilter = new UntypedFormControl('');
  statusFilter = new UntypedFormControl('');
  meetingTitleFilter = new UntypedFormControl('');
  dataSource: any;
  taskSearchDataSource!: TaskDataSource;
  filterValues = {
    taskTitle: '',
    assignedBy: '',
    ownerNames: '',
    dueOrCompDate: '',
    taskStatus: '',
    meetingTaskTitle: '',
  };

  id = new UntypedFormControl('');
  isLoading: boolean = false;
  taskSearchJSON: any;
  error: string | undefined;
  totalCount: any;
  searchValue: any = {};
  globalSearchValue: any;
  lastKeyPressed = 0;
  searchvalue: any;
  private countGlobal = new BehaviorSubject<number>(0);
  //isShown: boolean = false ;
  isFilterApplied: boolean = true;

  private searchFilterSub = new Subject();
  

  watchSearchFilter(): Observable<any> {
    return this.searchFilterSub.asObservable();
  }
  coulumnNames: string[] = ['taskTitle', 'assignedByName', 'ownerNames', 'dueOrCompDate', 'taskStatus', 'meetingTaskTitle'];
  constructor(private sideNav:SideNavServiceService,private globals: Globals, private route: ActivatedRoute, private datePipe: DatePipe, private searchService: SearchService, private router: Router, private dashboardService: DashboardService,private meetingService: MeetingService,) {
    this.taskSearchJSON =
    {
      "filterCol": "taskTitle",
      "filterText": "",
      "pageStart": 0,
      "pageEnd": 25,
      "reportedUsersId": this.globals.userId + "," + this.globals.repotingUsers,
      "searchText": "",
      "sortColumn": "meetingDate",
      "sortType": "desc",
      "type": "Task",
      "loggedUserId": localStorage.getItem("userId"),
      "visitorTimezone": localStorage.getItem("timeszone")
    }
    // this.isLoading = true;
    /*this.route.queryParams.subscribe(
      params => {
   
        if (params['data'] != undefined) {
          this.globalSearch(params['data']);
          this.globalSearchValue=params['data'];
        }
        setTimeout(() => {
          this.isLoading = false;
        }, 2000);
      }
    )*/

  }

  ngAfterViewInit() {
    this.paginator.pageIndex = this.taskSearchJSON.pageIndex;
    this.taskSearchDataSource.counter$
      .pipe(
        tap((count) => {
          this.paginator.length = count;
        })
      )
      .subscribe();
    this.paginator.page
      .pipe(
        tap(() => this.loadSearchTasks())

      )
      .subscribe();
  }
  loadSearchTasks() {
    this.taskSearchJSON.pageStart = this.paginator.pageIndex;
    this.taskSearchJSON.pageEnd = this.paginator.pageSize;
    this.taskSearchDataSource.loadSearchTasks(this.taskSearchJSON);
  }

  ngOnInit() {
    //this.isLoading = true;
    this.watchSearchFilter().pipe(debounceTime(1500)).subscribe((data: any) => {
      
      this.applyfilter(data);
    })
    /*this.storageSub.pipe(debounceTime(2000), distinctUntilChanged())
    .subscribe(term => {
 
      this.applyfilter(term);
    });*/
    this.taskSearchDataSource = new TaskDataSource(this.dashboardService);
    this.searchvalue = localStorage.getItem("tasksearchValue");
 
    if (this.searchvalue != null && this.searchvalue != "" && this.searchvalue!=undefined ) {
      this.searchvalue = JSON.parse(this.searchvalue);
      this.searchValue.taskTitle = this.searchvalue.taskTitle;
      this.searchValue.assignedBy = this.searchvalue.assignedBy;
      this.searchValue.assignedTo = this.searchvalue.assignedTo;
      this.searchValue.dueDate = this.searchvalue.dueDate;
      this.searchValue.status = this.searchvalue.status;
      this.searchValue.meetingTitle = this.searchvalue.meetingTitle;
      this.applyfilter(this.searchvalue);
    }
    else {
      this.taskSearchDataSource.loadSearchTasks(this.taskSearchJSON);
    }
    //}
    // this.isLoading = false;
  }
  redirectToMeeting(meetingId: number, searchValue: any) {
    
    this.meetingService.fetchMeetingWithStatusObject(meetingId).subscribe(
      (meetingRes: any) => {
       var meetingobject=meetingRes.body
        var req: any = { "meetingId": meetingId, "searchValue": searchValue };
        if (meetingobject.meetingStatusCode == "SCH" ){
          if(meetingobject.rescheduleFlag=="Y" && (meetingobject.meetingStartFlag == null||meetingobject.meetingStartFlag == undefined)){
            req={ "meetingId": meetingId, "searchValue": searchValue ,"flag":true,"meetingStartFlag":""}
          }else{
            this.sideNav.openInstantMeeting(true);
             req={ "meetingId": meetingId, "searchValue": searchValue ,"flag":true,meetingStartFlag:"Y"}
          }
        }else {
          req={ "meetingId":meetingId, "searchValue": searchValue ,"flag":true,showMoM : true}
        }
    this.router.navigate(['schedule'], { queryParams: { "meetingResult": JSON.stringify(req) }, skipLocationChange: true, replaceUrl: false });
  });
 }
  filterValue(data: any, event: any) {
    
    if (event.keyCode == 13) {
      this.applyfilter(data);
    } else {
      this.searchFilterSub.next(data);
    }
  }

  applyfilter(data: any) {
    
    localStorage.setItem("tasksearchValue",JSON.stringify(data));
 
    var filterCol = "";
    var filterVal = "";
    for (let i = 0; i < this.displayedColumns.length; i++) {
      if ((data[this.displayedColumns[i]]) != undefined) {
        if ((data[this.displayedColumns[i]]) != "") {
          filterCol = filterCol + (this.coulumnNames[i] + "#");
          if (this.displayedColumns[i] == "dueDate") {
            let dateFormat = this.datePipe.transform(data['dueDate'], "MMM dd, yyyy");
            filterVal = filterVal + (dateFormat + "#");
          }
          else {
            filterVal = filterVal + (data[this.displayedColumns[i]] + "#");
          }

        }
        else {
          filterCol = filterCol + "";
          filterVal = filterVal + "";
        }

      }
    }
    this.taskSearchJSON.pageStart = 0;
    this.taskSearchJSON.filterCol = filterCol;
    this.taskSearchJSON.filterText = filterVal;
    this.taskSearchDataSource.loadSearchTasks(this.taskSearchJSON);
  }


  sortData(sort: Sort) {
    if (sort.active == "dueDate") {
      this.taskSearchJSON.sortColumn = "meetingDate";
      this.taskSearchJSON.sortType = sort.direction;
      this.taskSearchDataSource.loadSearchTasks(this.taskSearchJSON);
    }
    else if (sort.active == "assignedBy") {
      this.taskSearchJSON.sortColumn = "assignedByName";
      this.taskSearchJSON.sortType = sort.direction;
      this.taskSearchDataSource.loadSearchTasks(this.taskSearchJSON);
    }
    else if (sort.active == "assignedTo") {
      this.taskSearchJSON.sortColumn = "ownerNames";
      this.taskSearchJSON.sortType = sort.direction;
      this.taskSearchDataSource.loadSearchTasks(this.taskSearchJSON);
    }
    else if (sort.active == "status") {
      this.taskSearchJSON.sortColumn = "taskStatus";
      this.taskSearchJSON.sortType = sort.direction;
      this.taskSearchDataSource.loadSearchTasks(this.taskSearchJSON);
    }
    else if (sort.active == "meetingTitle") {
      this.taskSearchJSON.sortColumn = "meetingTaskTitle";
      this.taskSearchJSON.sortType = sort.direction;
      this.taskSearchDataSource.loadSearchTasks(this.taskSearchJSON);
    }
    else if (sort.active == "taskTitle") {
      this.taskSearchJSON.sortColumn = "taskTitle";
      this.taskSearchJSON.sortType = sort.direction;
      this.taskSearchDataSource.loadSearchTasks(this.taskSearchJSON);
    }
  }
  resetData() {
    this.searchValue.taskTitle = "";
    this.searchValue.assignedBy = "";
    this.searchValue.assignedTo = "";
    this.searchValue.dueDate = "";
    this.searchValue.status = "";
    this.searchValue.meetingTitle = "";
    localStorage.setItem("tasksearchValue",JSON.stringify(this.searchValue));
    this.taskSearchJSON.filterCol = "taskTitle";
    this.taskSearchJSON.filterText = "";
    this.taskSearchJSON.pageStart = 0;
    this.taskSearchJSON.pageEnd = 10;
    this.taskSearchDataSource.loadSearchTasks(this.taskSearchJSON);
  }
  clearSearchField(data: any, text: any) {
    if (data == "taskTitle") {
      this.searchValue.taskTitle = "";
      this.applyfilter(text);
    }
    if (data == "assignedBy") {
      this.searchValue.assignedBy = "";
      this.applyfilter(text);
    }
    if (data == "assignedTo") {
      this.searchValue.assignedTo = "";
      this.applyfilter(text);
    }
    if (data == "dueDate") {
      this.searchValue.dueDate = "";
      this.applyfilter(text);
    }
    if (data == "status") {
      this.searchValue.status = "";
      this.applyfilter(text);
    }
    if (data == "meetingTitle") {
      this.searchValue.meetingTitle = "";
      this.applyfilter(text);
    }
  }
}
